module.exports = __webpack_public_path__ + "img/icon-warning.7df84df0.svg";